var React = require('react');

function DocumentsIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#606060","fillRule":"evenodd"},[React.createElement("path",{"d":"M10.347 4.284V0H2.432A2.43 2.43 0 0 0 0 2.427v18.598a2.43 2.43 0 0 0 2.432 2.426h13.375a2.43 2.43 0 0 0 2.433-2.426V7.875h-4.294a3.6 3.6 0 0 1-3.6-3.592zm4.075 14.839H3.15a.914.914 0 1 1 0-1.826h11.272a.914.914 0 1 1 0 1.826zm0-3.806H3.15a.914.914 0 1 1 0-1.826h11.272a.914.914 0 1 1 0 1.826zm.915-4.809c0 .505-.41.914-.915.914H3.15a.915.915 0 1 1 0-1.827h11.272c.505 0 .915.41.915.913z","key":0}),React.createElement("path",{"d":"M14.081 6.514h4.159L11.726 0v4.159c0 1.3 1.055 2.355 2.356 2.355z","key":1})]));
}

DocumentsIconInline.defaultProps = {"width":"19","height":"24"};

module.exports = DocumentsIconInline;

DocumentsIconInline.default = DocumentsIconInline;
